/* src/app/private/components/enrollment/enrollment-status/enrollment-status.component.scss */
.lead-status-container {
  display: flex;
  align-items: center;
  font-family: Arial, sans-serif;
  gap: 15px;
  min-width: 550px;
}
.status-box {
  padding: 5px 16px;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  min-width: 115px;
  border-radius: 0px;
  position: relative;
  color: black;
  min-width: fit-content;
  padding-left: 25px;
}
.completed {
  background-color: #a6c8ff;
  color: black;
}
.current {
  background-color: #ffe5b4;
  color: black;
}
.upcoming {
  background-color: #e0e0e0;
  color: black;
}
.status-box:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -13px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid;
  border-top-right-radius: 10px;
  border-radius: 3px;
}
.status-box:not(:first-child)::after {
  right: -13px;
}
.status-box:not(:first-child)::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -1px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid;
}
.completed:not(:last-child)::before {
  border-left-color: var(--p-card-background);
  z-index: 2;
}
.completed:not(:last-child)::after {
  border-left-color: #a6c8ff;
  z-index: 1;
}
.current:not(:last-child)::after {
  border-left-color: #ffe5b4;
  z-index: 1;
}
.current::before {
  border-left-color: var(--p-card-background) !important;
  z-index: 2;
}
.upcoming:not(:last-child)::after {
  border-left-color: #e0e0e0;
  z-index: 1;
}
.upcoming:not(:first-child)::before {
  border-left-color: var(--p-card-background);
  z-index: 1;
}
/*# sourceMappingURL=enrollment-status.component.css.map */
